import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../../lib/shared/validators";
import { customFieldValues } from "../../custom_fields";

export const personnelStatus = v.union(
  v.literal("active"),
  v.literal("inactive"),
);

export const paymentFrequency = v.union(
  v.literal("per_trip"),
  v.literal("per_service"),
  v.literal("weekly"),
  v.literal("biweekly"),
  v.literal("monthly"),
);

export const validatorPersonnel = v.object({
  name: v.string(),
  identification: v.optional(v.string()),
  phone: v.optional(v.string()),
  email: v.optional(v.string()),
  address: v.optional(v.string()),
  roleId: v.id("personnel_roles"),
  userId: v.optional(v.id("users")),
  rateOverride: v.optional(v.number()),
  paymentFrequency: v.optional(paymentFrequency),
  status: v.optional(personnelStatus),
  notes: v.optional(v.string()),
  internalControl,
  /** Valores de campos personalizados (Colecciones), por key de definición. */
  customFields: v.optional(customFieldValues),
});

export const personnel = defineTableWithInternalControl(validatorPersonnel)
  .index("by_role", ["roleId"])
  .index("by_user", ["userId"])
  .index("by_company_and_role", ["internalControl.companyId", "roleId"])
  .index("by_branch_and_role", ["internalControl.branchId", "roleId"])
  .searchIndex("search_personnel", {
    searchField: "name",
    filterFields: ["internalControl.companyId", "internalControl.branchId"],
  });
